import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getUserDetails),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(watchGetUserDetails);

import { put, call, fork, take } from 'redux-saga/effects';
import makeApiRequest from '../../../utils/makeApiRequest';
import { GET_USER_DETAILS, getUserDetailsRequest, getUserDetailsSuccess, getUserDetailsFailure } from '../../../redux/userDetails/getDetails';
import { queryGetWishlistPartNumbers } from '../../../utils/gql-queries';
import flattenQuery from '../../../utils/flattenQuery';
import { getGlobalItems } from '../../../redux/globalList/getItems';
import { getLocalItems } from '../../../redux/localList/getItems'; // -------------------------------------------------
// WORKER SAGAS
// -------------------------------------------------

export function getUserDetails(getWishlist) {
  var payload, data, userState;
  return _regeneratorRuntime.wrap(function getUserDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(getUserDetailsRequest());

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return call(makeApiRequest, {
            methodType: 'get',
            url: '/webapp/wcs/stores/servlet/GetUserInfo'
          });

        case 5:
          payload = _context.sent;
          data = payload === null || payload === void 0 ? void 0 : payload.data;
          _context.next = 9;
          return put(getUserDetailsSuccess(data));

        case 9:
          if (!(getWishlist && data)) {
            _context.next = 19;
            break;
          }

          userState = data.userState;

          if (!(userState === 'LOGGEDIN')) {
            _context.next = 16;
            break;
          }

          _context.next = 14;
          return put(getGlobalItems(flattenQuery(queryGetWishlistPartNumbers)));

        case 14:
          _context.next = 19;
          break;

        case 16:
          if (!(userState === 'RECOGNISED' || userState === 'GUEST')) {
            _context.next = 19;
            break;
          }

          _context.next = 19;
          return put(getLocalItems());

        case 19:
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](2);
          _context.next = 25;
          return put(getUserDetailsFailure('There has been an error attempting to retrieve your user details'));

        case 25:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 21]]);
} // -------------------------------------------------
// WATCHER SAGAS
// -------------------------------------------------

export default function watchGetUserDetails() {
  var _yield$take, getWishlist;

  return _regeneratorRuntime.wrap(function watchGetUserDetails$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 9;
            break;
          }

          _context2.next = 3;
          return take(GET_USER_DETAILS);

        case 3:
          _yield$take = _context2.sent;
          getWishlist = _yield$take.getWishlist;
          _context2.next = 7;
          return fork(getUserDetails, getWishlist);

        case 7:
          _context2.next = 0;
          break;

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}